///<reference path="./roomlist/roomlist.ts"/>
///<reference path="../../app/d/app.d.ts" />

declare var __fanclubCurrency: string; // global variable
declare var notificationPopup: any; // global variable

var babesHandler = null;
var roomListNG = null;

module Sxc.Site {

    export function initialize(): void {
        roomListNG = new Sxc.Site.RoomList();
    }
}

Sxc.Site.initialize();

